// What this clinic's screens call the people it cares for: "mother" (Suraksha Sathi) or "patient" (later programmes).
// Set from the clinic's programmes (programmeService.personTermFor), never hard-coded in screens.
import { createContext } from 'react';
import type { PersonTerm } from '../services/programmeService';

export type { PersonTerm };
export const TermContext = createContext<PersonTerm>('mother');
